module.exports = __webpack_public_path__ + "static/media/Apples Script Demo-01.1138df98.svg";